import { auth } from './config'

export const getAuthHeaders = async () => {
    const user = auth.currentUser
    if (!user) return {}
    const token = await user.getIdToken()
    return { Authorization: `Bearer ${token}` }
}
